import {
  Badge,
  Box,
  Button,
  ExternalLinkIcon,
  TableCell,
  TableRow,
  Text,
} from '@razorpay/blade/components';
import { StatusBadge } from 'components/SalaryComponents/components/StatusBadge';
import { SalaryStructure } from 'components/SalaryStructure/types';

interface SalaryStructureRowProps {
  structure: SalaryStructure;
  onViewDetails: (structureId: string) => void;
}

const SalaryStructuresListTableRow = ({
  structure,
  onViewDetails,
}: SalaryStructureRowProps) => {
  return (
    <TableRow
      key={structure.id}
      item={structure}
      onClick={() => onViewDetails(structure.id)}
      hoverActions={
        <Button
          variant="tertiary"
          color="primary"
          size="medium"
          icon={ExternalLinkIcon}
          iconPosition="right"
          onClick={() => onViewDetails(structure.id)}
          testID={`view-details-button-${structure.id}`}>
          View Details
        </Button>
      }>
      <TableCell>
        <Box display="inline-flex" gap="spacing.3">
          <Text>{structure.name}</Text>
          {structure.type === 'SALARY_STRUCTURE_TYPE_DEFAULT' && (
            <Badge color="primary" size="medium">
              Organization default
            </Badge>
          )}
        </Box>
      </TableCell>
      <TableCell>
        <Text variant="caption" color="surface.text.gray.muted">
          {structure.description}
        </Text>
      </TableCell>
      <TableCell>
        <StatusBadge isActive={structure.status === 'SALARY_STRUCTURE_STATUS_ACTIVE'} />
      </TableCell>
      <TableCell>
        <Text>{structure.employeeCount}</Text>
      </TableCell>
    </TableRow>
  );
};

export default SalaryStructuresListTableRow;
